import router from "@/router";
export default class GoToAction {
    routeName;
    constructor(routeName) {
        this.routeName = routeName;
    }
    run() {
        router.push({ name: this.routeName });
    }
}
